import { useState, useCallback } from "react";
import { api } from "@/services/api";

export type AdminMode = "owner" | "agent" | "admin";

const STORAGE_KEY = "adminActiveMode";

export function useAdminMode() {
  const [activeMode, setActiveMode] = useState<AdminMode>(() => {
    return (sessionStorage.getItem(STORAGE_KEY) as AdminMode) || "admin";
  });

  const switchMode = useCallback(async (mode: AdminMode) => {
    await api.post("/management/switch-mode", { mode });
    sessionStorage.setItem(STORAGE_KEY, mode);
    setActiveMode(mode);
  }, []);

  return { activeMode, switchMode, availableModes: ["owner", "agent", "admin"] as const };
}
